function QueryString(qs)
{
    this.dict= {};

    // If no query string  was passed in use the one from the current page
    if (!qs) qs= location.search;

    if (typeof qs === 'string') {
      // Delete leading question mark, if there is one
      if (qs.charAt(0) == '?') qs= qs.substring(1);

      // Parse it
      var re= /([^=&]+)(=([^&]*))?/g;
      var match;
      while (match= re.exec(qs))
      {
        var key= decodeURIComponent(match[1].replace(/\+/g,' '));
        var value= match[3] ? QueryString.decode(match[3]) : '';
        if (this.dict[key])
            this.dict[key].push(value);
        else
            this.dict[key]= [value];
      }
    } else {
      // handle passing in objects directly:
      for( var key in qs) {
        var val = qs[key];
        if (typeof val !== 'undefined') {
          if (Array.isArray(val)) {
            this.dict[key] = val;
          } else {
            this.dict[key] = [val];
          }
        }
      }

    }

}

QueryString.decode= function(s)
{
    s= s.replace(/\+/g,' ');
    s= s.replace(/%([EF][0-9A-F])%([89AB][0-9A-F])%([89AB][0-9A-F])/gi,
      function(code,hex1,hex2,hex3)
      {
          var n1= parseInt(hex1,16)-0xE0;
          var n2= parseInt(hex2,16)-0x80;
          if (n1 == 0 && n2 < 32) return code;
          var n3= parseInt(hex3,16)-0x80;
          var n= (n1<<12) + (n2<<6) + n3;
          if (n > 0xFFFF) return code;
          return String.fromCharCode(n);
      });
    s= s.replace(/%([CD][0-9A-F])%([89AB][0-9A-F])/gi,
      function(code,hex1,hex2)
      {
          var n1= parseInt(hex1,16)-0xC0;
          if (n1 < 2) return code;
          var n2= parseInt(hex2,16)-0x80;
          return String.fromCharCode((n1<<6)+n2);
      });
    s= s.replace(/%([0-7][0-9A-F])/gi,
      function(code,hex)
      {
          return String.fromCharCode(parseInt(hex,16));
      });
    return s;
};

QueryString.prototype.value= function (key)
{
    var a= this.dict[key];
    return a ? a[a.length-1] : undefined;
};

QueryString.prototype.values= function (key)
{
    var a= this.dict[key];
    return a ? a : [];
};

QueryString.prototype.keys= function ()
{
    var a= [];
    for (var key in this.dict)
  a.push(key);
    return a;
};

QueryString.prototype.toString= function ()
{
    var params= [];
    for (var key in this.dict) {
      var values = this.values(key);
      for (var i = 0; i < values.length; i++) {
        var value = values[i];
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      };
    }

    return params.join('&');
};

QueryString.prototype.toSingleValueDict= function ()
{
  var dict = {};
  for (var key in this.dict) {
    var values = this.values(key);
    if( values.length !== 1) {
      throw ("QueryString param "+key+" is not a single value: " + values.join(', '));
    }
    dict[key] = values[0];

  }

  return dict;
}

QueryString.prototype.toValuesDict = function ()
{
  var dict = {};
  for (var key in this.dict) {
    var values = this.values(key);
    if( values.length > 1) {
      dict[key] = values;
    }  else {
      dict[key] = values[0];
    }


  }
  return dict;
}


QueryString.prototype.toFirstValueDict = function ()
{
  var dict = {};
  for (var key in this.dict) {
    var values = this.values(key);
    dict[key] = values[1];

  }
  return dict;
}

QueryString.prototype.toLastValueDict = function ()
{
  var dict = {};
  for (var key in this.dict) {
    dict[key] = this.value(key);

  }
  return dict;
}

QueryString.makeQuery = function(query, querySeparator = '?') {
  if (typeof query !== 'string' && !(query instanceof QueryString)) {
    query = new QueryString(query);
  }
  if (query.toString().length > 0) {
    return '?' + query.toString();
  } else {
    return '';
  }
}

QueryString.combineSearchAndHash = function (search = window.location.search,
                                             hash = window.location.hash) {
  let searchDict = new QueryString(search).toSingleValueDict();
  let match = hash.match(/^#\?(.*)$/);

  if (match) {
    let hashDict = new QueryString(match[1]).toSingleValueDict();

    return Object.assign(searchDict, hashDict);
  } else {
    return searchDict;
  }
};

export default QueryString;


// WEBPACK FOOTER //
// ./lib/brave-utils/query-string.js